module.exports = __webpack_public_path__ + "img/no-img.bb9c4fe3.af242662.png";